export default {"src":"/_next/static/media/orders-icon.f93dabec.svg","height":16,"width":16};